import { ENVIRONMENTS } from "./config/env";
import env from "./config/env";
import axios from "axios";
import { Auth } from "aws-amplify";
export const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });


  export const getEnvSpecificAxiosInstance= async (contentType,defaultAxiosInstance,featurePath,url)=>{
    let axiosInstance = defaultAxiosInstance;
    const config = {
        headers:{},
    };

    if(env.name===ENVIRONMENTS.DEVELOPMENT.name){
        axiosInstance = axios;
        url=`/v1/${featurePath}/${url}`;
        //manually add auth token here as as are bypassing interceptor
        config.headers.Authorization=`Bearer ${(await Auth.currentSession()).getIdToken()?.getJwtToken()}`;
        config.headers.version='v1';
    }
    return {
        AXIOS: axiosInstance,
        URL: url,
        config
    };
}